import { render, staticRenderFns } from "./RatingsModal.vue?vue&type=template&id=87ab212a&scoped=true"
import script from "./RatingsModal.vue?vue&type=script&lang=js"
export * from "./RatingsModal.vue?vue&type=script&lang=js"
import style0 from "./RatingsModal.vue?vue&type=style&index=0&id=87ab212a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ab212a",
  null
  
)

export default component.exports